

export const TypeChecker = <TEntity>(obj: any, validationCallback?: (entity: TEntity) => boolean): obj is TEntity => {
    const temp = obj as TEntity,
        result = (validationCallback == null && temp != null) || (validationCallback != null && validationCallback(temp));
    return result;
}
